
import axios from 'axios';
import { logoutUser } from '../components/utility/constants';

const fastapiAxios = axios.create({
  baseURL: process.env.REACT_APP_FASTAPI_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// attach token
fastapiAxios.interceptors.request.use(
  config => {
    if (localStorage.token) {
      config.headers.Authorization = `Bearer ${localStorage.token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// handle auth errors
fastapiAxios.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      logoutUser();
    }
    return Promise.reject(error);
  }
);

export default fastapiAxios;